import { computed, makeObservable, observable } from "mobx"

import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import { GlobalWhiteListCollection } from "@src/app/whitelistStore/WhiteListCollection"
import { capitalizeFirstLetter } from "@src/pages/settingsWhitelist/capitalizeFirstLetter"
import { catchErrors, whitelistAddressesApi } from "@src/shared/api"
import { loading } from "@src/shared/classes/utils/loading"

export type WhiteListCreateReq = {
  address: string
  name: string
  network: string
}

export class WhiteList extends loading(["delete", "create"]) {
  constructor(
    public collection = GlobalWhiteListCollection(),
    public currencies = GlobalCurrenciesCollection(),
  ) {
    super()

    makeObservable(this, { currenciesOption: computed })
  }

  async create(req: WhiteListCreateReq) {
    return whitelistAddressesApi
      .createWhitelistAddress(req)
      .then(this.collection.load)
  }

  async delete(id: string) {
    return whitelistAddressesApi
      .deleteWhitelistAddress(id)
      .catch(catchErrors)
      .then(this.collection.load)
  }

  get currenciesOption() {
    const uniqueAddresses = [
      ...new Set(this.currencies.items?.map((item) => item.network)),
    ]

    return (
      uniqueAddresses?.map((item) => ({
        label: capitalizeFirstLetter(item),
        value: item,
      })) || []
    )
  }
}
